import React from "react";
import { Outlet, Navigate, useLocation } from "react-router-dom";
import { CircularProgress, Box } from "@mui/material";
import useData from "../Hooks/useData";

const RequireAuth = ({ allowedRoles }) => {
  const { auth, isAuthLoading } = useData();
  const location = useLocation();

  // While auth is being validated against the backend, show a loading indicator.
  // This prevents any protected UI from flashing before validation completes.
  if (isAuthLoading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "60vh" }}>
        <CircularProgress />
      </Box>
    );
  }

  //console.log('Auth',auth);
  // Not authenticated — redirect to login, preserving the intended destination
  if (!auth) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // If allowedRoles is provided and non-empty, enforce role-based access
  if (allowedRoles && allowedRoles.length > 0) {
    const userRoleIds = Array.isArray(auth?.roles)
    ? auth.roles.map(r => r.RoleID)
    : [];
    const hasRequiredRole = allowedRoles.some((role) => userRoleIds.includes(role));
    if (!hasRequiredRole) {
      return <Navigate to="/unauthorized" replace />;
    }
  }

  return <Outlet />;
};

export default RequireAuth;
